import EmployeeListRow from './EmployeeListRow';

const EmployeeListTable = ({ employees, edit }) => {

  return (
    <div>
      {employees.length > 0 && (
        <table className="w-full text-sm border-separate border-spacing-x-6">
          <thead>
            <tr className="text-gray-600 border-b">
              <th className="py-2 text-left">Emp_ID</th>
              <th className="py-2 text-left">Name</th>
              <th className="py-2 text-left">Department</th>
              <th className="py-2 text-left">Designation</th>
              <th className="py-2 text-left">Reporting to</th>
              <th className="py-2 text-left">Employment Type</th>
              <th className="py-2 text-left">Duration</th>
            </tr>
          </thead>
          <tbody>
            {employees.map((emp) => (
              <EmployeeListRow emp={emp} key={emp.id} edit={edit} />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default EmployeeListTable